import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cloud-app-footer',
  templateUrl: './footer.component.html',
  styleUrls: [
    './footer.component.scss',
    './footer.component-theme.scss'
  ]
})

export class FooterComponent implements OnInit {
  year = new Date().getFullYear();
  boricaLogo = '../../../assets/images/logos/borica-logo-bg.svg';

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.translateService.onLangChange.subscribe((event) => {
      this.boricaLogo = '../../../assets/images/logos/borica-logo-' + event.lang + '.svg';
    });
  }
}
